'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../constants/colors';
import { LegendPositions, LegendWidthTypes } from '../../visualizations/commonRecords';
import { DEFAULT_LEGEND_WIDTH } from '../../constants/legend';
import { encodeHTMLEntities } from '../../formatters/utils';
export const legendPositionToOptions = {
  [LegendPositions.TOP]: {
    chart: {
      spacingTop: 44
    },
    legend: {
      maxHeight: 40,
      verticalAlign: 'top',
      align: 'left'
    }
  },
  [LegendPositions.BOTTOM]: {
    chart: {
      spacingBottom: 44
    },
    legend: {
      maxHeight: 40,
      verticalAlign: 'bottom',
      align: 'left',
      y: 50
    }
  },
  [LegendPositions.RIGHT]: {
    chart: {},
    legend: {
      maxHeight: undefined,
      verticalAlign: 'middle',
      align: 'right',
      layout: 'vertical',
      floating: false,
      y: 0
    }
  },
  [LegendPositions.LEFT]: {
    chart: {},
    legend: {
      maxHeight: undefined,
      verticalAlign: 'middle',
      align: 'left',
      layout: 'vertical',
      floating: false,
      y: 0
    }
  }
};
const formatLegendWidth = legendWidth => {
  switch (legendWidth.type) {
    case LegendWidthTypes.PERCENT:
      return `${legendWidth.value.toString()}%`;
    case LegendWidthTypes.PIXEL:
      return `${legendWidth.value.toString()}px`;
    default:
      return undefined;
  }
};
export const getLegendPositionOptions = (legendPosition, legendWidth) => {
  const positionOptions = legendPositionToOptions[legendPosition || LegendPositions.TOP];
  if ([LegendPositions.RIGHT, LegendPositions.LEFT].includes(legendPosition)) {
    return {
      chart: Object.assign({}, positionOptions.chart),
      legend: Object.assign({
        width: formatLegendWidth(legendWidth || DEFAULT_LEGEND_WIDTH)
      }, positionOptions.legend)
    };
  }
  return positionOptions;
};
export const defaultLegendOptions = fromJS({
  enabled: true,
  borderWidth: 0,
  symbolRadius: 4,
  symbolWidth: 8,
  symbolHeight: 8,
  itemMarginBottom: 4,
  floating: true,
  align: 'left',
  verticalAlign: 'top',
  maxHeight: 40,
  alignColumns: false,
  y: -50,
  itemStyle: {
    color: colors.TEXT_COLOR,
    fontSize: '12px',
    fontWeight: 400,
    textDecoration: 'none'
  },
  labelFormatter() {
    return encodeHTMLEntities(this.name);
  },
  navigation: {
    activeColor: 'var(--trellis-color-icon-core-default)',
    inactiveColor: 'var(--trellis-color-icon-core-disabled)',
    style: {
      color: colors.TEXT_COLOR,
      fontSize: '12px'
    }
  }
});